<template>
  <div class="container">
    <div class="tabs is-centered" style="background-color: #FFFFFF;">
      <ul style="margin: 0">
        <li :class="{'is-active': activeIndex === index}"
            v-for="(tab,index) in tabsData" :key="index" @click="changeTabs(index)">
          <a>
            <span class="label-input">{{ $t(`pages.${tab.name}`) }}</span>
            <div class="badge-color">
              ({{ tab.count === null ? '-' : tab.count }})
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div class="tab-item">
        <keep-alive>
          <component :is="selectedTab.component"
                     @dataCountUpdated="updateDataCount"
                     :ref="selectedTab.ref"
                     :checkUser="checkUser"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ParcelOutBoundWaiting from "@views/SuperAdmin/Parcel/ParcelDistributionCenter/TabDistributionStatus/Un-Outbound";
import ParcelOutBound from "@views/SuperAdmin/Parcel/ParcelDistributionCenter/TabDistributionStatus/Outbound";
import ParcelInbound from "@views/SuperAdmin/Parcel/ParcelDistributionCenter/TabDistributionStatus/Inbound";
import ParcelInboundWaiting from "@views/SuperAdmin/Parcel/ParcelDistributionCenter/TabDistributionStatus/Un-Inbound";

export default {
  name: "Index",
  data() {
    return {
      activeIndex: 0,
      tabsData: [
        {
          name: "ເຄື່ອງຄ້າງສູນ",
          component: ParcelOutBoundWaiting,
          count: null,
          ref: 'unOutbound'
        },
        {
          name: "ຍິງເຄື່ອງອອກ",
          component: ParcelOutBound,
          count: null,
            ref: 'outbound'
        },
        {
          name: "ຍິງເຄື່ອງເຂົ້າ",
          component: ParcelInbound,
          count: null,
           ref: 'inbound'
        },
        {
          name: "ລໍຖ້າຍິງເຂົ້າ",
          component: ParcelInboundWaiting,
          count: null,
           ref: 'unInbound'
        }
      ],
      checkUser: {
        distribution_center: {},
      },
      setNewDistributionCenterId: "",
    }
  },
  computed: {
    selectedTab() {
      return this.tabsData[this.activeIndex]
    }
  },
  methods: {
    changeTabs(index) {
      this.activeIndex = index;
    },
    updateDataCount(dataCount) {
      this.tabsData[this.activeIndex].count = dataCount.count || 0;
    },
  },
  watch: {
    'checkUser': function (val) {
      if (val && val.distribution_center) {
        this.$store.commit("set_DistributionCenter", val.distribution_center === null ? 5 : val.distribution_center.id)
      }
    }
  },
  created() {
    this.$http.get(`list-my-profile`).then((res) => {
      this.checkUser = res.data;
      if (this.checkUser && this.checkUser.distribution_center) {
        this.$store.commit("set_DistributionCenter", this.checkUser.distribution_center.id)
      } else {
        this.$store.commit("set_DistributionCenter", 5)
      }
      const unOutboundRef = this.$refs.unOutbound;
      if(unOutboundRef) {
        unOutboundRef.firstInit()
      }
    }).catch(() => {
    })
    if (this.$can('service')) {
      this.$store.commit("set_service_role","service")
    }
  }
}
</script>

<style scoped lang="scss">
.badge-color {
  font-weight: 900;
  margin-left: 12px;
  color: red;
}
</style>
